import { Users, Loader2 } from 'lucide-react';
import { ExistingInvestorListItem } from './InvestorListItem';
import type { ExistingInvestor } from '../types';

interface ExistingInvestorsSectionProps {
  existingInvestors: ExistingInvestor[];
  loadingBatches: boolean;
}

export function ExistingInvestorsSection({
  existingInvestors,
  loadingBatches,
}: ExistingInvestorsSectionProps) {
  if (existingInvestors.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Users className="h-5 w-5 text-muted-foreground" />
        <h3 className="font-semibold">
          Existing Investors ({existingInvestors.length})
        </h3>
      </div>

      <div className="border rounded-lg divide-y max-h-[300px] overflow-y-auto">
        {loadingBatches ? (
          <div className="p-8 flex items-center justify-center text-muted-foreground">
            <Loader2 className="h-6 w-6 animate-spin mr-2" />
            <span>Loading existing investors...</span>
          </div>
        ) : (
          existingInvestors.map((investor) => (
            <ExistingInvestorListItem
              key={investor.investor_id}
              investorName={investor.investor_name}
              commitmentAmount={investor.commitment_amount}
              drawdownAmount={investor.drawdown_amount}
              batchName={investor.batch_name}
            />
          ))
        )}
      </div>
    </div>
  );
}
